import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { ParkAreaAssesment } from '@services/park-area-assesment';
import { ParkAreaAssesmentStatus } from '@services/park-area-assesment/park-area-assesment-status.enum';
import { Site } from '@services/site';
import { Organization } from '@services/organization';
import { AccessType } from './access-type.enum';
import { CoverageAndAccessibility } from './coverage-and-accessibility.enum';
import { InstallationType } from './installation-type.enum';

export class ParkArea extends BaseEntity {
	name: string;
	access?: AccessType;
	coverageAndAccessibility?: CoverageAndAccessibility;
	installationType?: InstallationType;
	floorInstallation?: boolean;
	powerAvailableForCharging?: number;
	parkingSlotsNumber: number;
	currentACInstalled?: number;
	currentDCInstalled?: number;
	currentCPOInstalled?: number;
	assesment?: ParkAreaAssesment; // added by FE
	siteId: string;

	@Type(() => Site)
	site: Site;

	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	finalACToBeInstalled: number;
	finalDCToBeInstalled: number;
	finalCPOToBeInstalled: number;

	setAssesment(assesment?: ParkAreaAssesment) {
		this.assesment = assesment;
		return this;
	}

	get status(): ParkAreaAssesmentStatus {
		return this.assesment?.status || ParkAreaAssesmentStatus.NOT_STARTED;
	}
}
